import { t } from "ttag";

import { ConsultationLanguagePreference } from "@/app/components/legacy-components";
import { Card } from "@/shared/ui";

export const LanguagePreference = () => {
  return (
    <Card.Root className="gap-6 lg:flex-row lg:items-center">
      <Card.Title>{t`Consultation language preference`}</Card.Title>

      <ConsultationLanguagePreference />
    </Card.Root>
  );
};
